var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.2,428L28.8,54c-5.5-4.4-13.6-3.5-18,2l0,0l-8,10c-4.4,5.5-3.5,13.6,2,18l0,0l478.4,374c5.5,4.4,13.6,3.5,18-2l8-10 C513.6,440.5,512.7,432.4,507.2,428L507.2,428z M237.4,168.4l107.8,84.3c-1.8-48-40.9-86.3-89.3-86.3 C249.8,166.4,243.5,167.1,237.4,168.4z M274.6,343.6l-107.8-84.3c1.8,47.9,40.9,86.3,89.3,86.3C262.2,345.6,268.5,344.9,274.6,343.6 L274.6,343.6z M256,140.8c78.9,0,151.3,44,190.3,115.2c-9.6,17.5-21.4,33.7-35.2,48.2l30.2,23.6c16.8-18,31.1-38.2,42.3-60.1 c3.7-7.3,3.7-16,0-23.4C440.2,159.7,354.3,102.4,256,102.4c-29.4,0-57.4,5.6-83.7,15l37.1,29C224.6,143,240.1,140.8,256,140.8z  M256,371.2c-78.9,0-151.3-44-190.3-115.2c9.6-17.5,21.4-33.7,35.2-48.2l-30.2-23.6c-16.8,18-31,38.2-42.3,60.1 c-3.7,7.3-3.7,16,0,23.4C71.8,352.3,157.7,409.6,256,409.6c29.4,0,57.4-5.6,83.7-15l-37.1-29C287.4,369,271.9,371.2,256,371.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.22a30cfa12ecf2559fde07b479817952.svg";
export { ForwardRef as ReactComponent };